<template>
  <div class="content-container">
    <BGAnimation :right="true" />
    <div class="content">
      <div class="menu">
        <b-button variant="link" class="d-lg-none" @click="$emit('menu-click')">
          <b-icon icon="list" variant="primary" />
        </b-button>
      </div>
      <div class="page">
        <b-container>
          <transition name="scale" mode="out-in">
            <router-view></router-view>
          </transition>
        </b-container>
      </div>
    </div>
  </div>
</template>

<script>
import BGAnimation from '../widgets/BGAnimation.vue'
export default {
  name: 'Content',
  components: { 
    BGAnimation 
  },
}
</script>

<style lang="scss" scoped>
.dark-theme {
  .content-container {
    background-color: $dark;
  }
}
.content-container {
  position: relative;
  grid-area: content;
  margin: 0px;
  height: 100%;
  padding-top: 20px;
  padding-bottom: 20px;
  overflow: hidden;
  border-radius: 1rem;
  background-color: #ffffff;
  .content {
    height: 100%;
    width: 100%;
    position: relative;
    z-index: 1;
    > .menu {
      display: flex;
      align-items: center;
      justify-content: start;
      padding-left: 1rem;
    }
    > .page {
      height: 100%;
      overflow: auto;
    }
  }
}
.scale {
  &-enter-active,&-leave-active {
    transition: all 0.5s ease;
  }
  &-enter-from,&-leave-to {
    opacity: 0;
    transform: scale(0.9);
  }
}
</style>